"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNSUBSCRIBED_ONETRUST_STATUS_ARR = exports.SUBSCRIBED_ONETRUST_STATUS_ARR = void 0;
var SUBSCRIBED_ONETRUST_STATUS_ARR = exports.SUBSCRIBED_ONETRUST_STATUS_ARR = ['CONFIRMED', 'ACTIVE', 'NOT_OPTED_OUT', 'ALWAYS_ACTIVE'];
var UNSUBSCRIBED_ONETRUST_STATUS_ARR = exports.UNSUBSCRIBED_ONETRUST_STATUS_ARR = ['WITHDRAWN', 'OPT_OUT', 'EXPIRED', 'NO_CONSENT', 'HARD_OPT_OUT'];